import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../../redux/AppDucks'
import Collapsible from 'react-collapsible';
import estilos from './FormularioFC01BeneficiarioComponent.module.css';
import { ArchivoComponent } from '../../ArchivosComponents/ArchivoComponent';
import {
    actualizarFC_01Estatus, actualizarFileFC_01, agregarFileFC_01, eliminarFileFC_01,
    actualizarFC_01Fecha
} from '../../../redux/DucksBeneficiario/FC_01Ducks';
import ArchivosMarcaComponent from '../../ArchivosComponents/ArchivosMarcaComponent';
import ArchivosPrediosViveros from '../../ArchivosComponents/ArchivosPrediosViveros';
import ArchivosInstalaciones from '../../ArchivosComponents/ArchivosInstalaciones';
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
import ModalEnviadoCorrectamente from '../../App/ModalEnviadoCorrectamente';
import moment from 'moment'

const DocumentacionFC_01Component = (props) => {
    const dispatch = useDispatch()
    const modoCorreccion = useSelector(store => store.FC_01Solicitud.modoCorreccion)
    let data = useSelector(store => store.FC_01Solicitud.data)
    let fc_01 = useSelector(store => store.FC_01Solicitud.fc_01)
    const filesFC_01 = useSelector(store => store.FC_01Solicitud.files)
    const fechaHoy = moment().format('YYYY-MM-DD');

    const filesApoderadosLegFC_01 = useSelector(store => store.FC_01Solicitud.filesApoderadosLeg)
    const filesPersonasAutFC_01 = useSelector(store => store.FC_01Solicitud.filesPersonasAut)
    const filesMarcasFC_01 = useSelector(store => store.FC_01Solicitud.filesMarcas)
    const filesMarcasProductFC_01 = useSelector(store => store.FC_01Solicitud.filesMarcasProduct)
    const filesInstalacionesFC_01 = useSelector(store => store.FC_01Solicitud.filesInstalaciones)
    const filesPrediosFC_01 = useSelector(store => store.FC_01Solicitud.filesPredios)
    const filesViverosFC_01 = useSelector(store => store.FC_01Solicitud.filesViveros)
    const filesResponsablesFC_01 = useSelector(store => store.FC_01Solicitud.filesResponsables)

    const opcionesFilesPrediosFC_01 = useSelector(store => store.FC_01Solicitud.opcionesFilesPredios)
    const opcionesFilesViverosFC_01 = useSelector(store => store.FC_01Solicitud.opcionesFilesViveros)
    const opcionesFilesInstalacionesFC_01 = useSelector(store => store.FC_01Solicitud.opcionesFilesInstalaciones)

    const documentacionFC_01Map = useSelector(store => store.FC_01Solicitud.documentacionFC_01Map)
    const documentacionRepresentanteLegalMap = useSelector(store => store.FC_01Solicitud.documentacionRepresentanteLegalMap)
    const documentacionPersonaAutorizadaMap = useSelector(store => store.FC_01Solicitud.documentacionPersonaAutorizadaMap)
    const documentacionPredioMap = useSelector(store => store.FC_01Solicitud.documentacionPredioMap)
    const documentacionViveroMap = useSelector(store => store.FC_01Solicitud.documentacionViveroMap)
    const documentacionMarcaMap = useSelector(store => store.FC_01Solicitud.documentacionMarcaMap)
    const documentacionMarcaProductoMap = useSelector(store => store.FC_01Solicitud.documentacionMarcaProductoMap)
    const documentacionInstalacionMap = useSelector(store => store.FC_01Solicitud.documentacionInstalacionMap)
    const documentacionResponsableMap = useSelector(store => store.FC_01Solicitud.documentacionResponsableMap)

    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const [envioCorrecto, setEnvioCorrecto] = React.useState(false)
    const obtenerNumeroDeFiles = async () => {
        let contadorArchivo = 0
        if (data.personamoral) {
            contadorArchivo += contadorMoralGeneral()
            contadorArchivo += contadorMarcas()
            contadorArchivo += contadorPredios()
            contadorArchivo += contadorInstalaciones()
        } else {
            contadorArchivo += contadorFisicaGeneral()
            contadorArchivo += contadorMarcas()
            contadorArchivo += contadorPredios()
            contadorArchivo += contadorInstalaciones()
        }

        const totalFilesGenerales = (files.filter(file => file.estatus === true && file.id !== "DGCP")).length
        const totalFilesApoderados = (filesApoderadosLeg.filter(file => file.estatus === true)).length
        const totalFilesPersonasAut = (filesPersonasAut.filter(file => file.estatus === true)).length
        const totalFilesPredios = (filesPredios.filter(file => file.estatus === true)).length
        const totalFilesViveros = (filesViveros.filter(file => file.estatus === true)).length
        const totalFilesMarcas = (filesMarcas.filter(file => file.estatus === true)).length
        const totalFilesMarcasProduct = (filesMarcasProduct.filter(file => file.estatus === true)).length
        const totalFilesInstalaciones = (filesInstalaciones.filter(file => file.estatus === true)).length
        const totalFilesResponsables = (filesResponsables.filter(file => file.estatus === true)).length
        const countFiles = totalFilesGenerales + totalFilesApoderados + totalFilesPersonasAut + totalFilesPredios
            + totalFilesViveros + totalFilesMarcas + totalFilesMarcasProduct + totalFilesInstalaciones
            + totalFilesResponsables
        if (contadorArchivo > countFiles) {
            setvalidacion(true)
            settexto("")
        } else {
            let fecha = new Date(fechaHoy).toISOString()
            let solicitud = { fechasolicitud: fecha, idfc01_solicitudregistro: data.idfc01_solicitudregistro }
            await dispatch(actualizarFC_01Fecha(solicitud))
            const idSolicitud = data.idfc01_solicitudregistro
            const estatusNuevo = 2
            await dispatch(actualizarFC_01Estatus(
                { data: { idSolicitud: idSolicitud, estatus: estatusNuevo, folio: data.folio } }
            ))
            setEnvioCorrecto(true)
        }
    }

    const contadorFisicaGeneral = () => {
        let contador = 0
        if (data.viverista || data.productormaguey || data.productormezcal || data.envasador || data.comercializadorbebidasconmezcal || data.comercializadormezcal) {
            contador += 2
        }
        if (data.representantelegalsi === true) contador += 1
        if (data.certificacionsi === true) contador += 1
        if (data.fc_01_anexopersonaautorizadatramites.length > 0) contador += data.fc_01_anexopersonaautorizadatramites.length
        return contador
    }
    const contadorPredios = () => {
        let contador = 0
        if (data.fc_01_anexovivero.length > 0 && data.viverista) {
            for (const i in opcionFileVivero) {
                if (opcionFileVivero[i].opcionFile === 'copiaescritura') contador++
                else if (opcionFileVivero[i].opcionFile === 'constanciaposesion') contador++
                else if (opcionFileVivero[i].opcionFile === 'contratoarrendamiento') contador += 3
                else if (opcionFileVivero[i].opcionFile === 'contratocompraventa') contador += 3
            }
            // contador += predios.length
            if (opcionFileVivero.length !== data.fc_01_anexovivero.length) contador++
        }
        if (data.fc_01_anexoproductor.length > 0 && data.productormaguey) {
            // contador += productor.length
            for (const i in opcionFilePredio) {
                if (opcionFilePredio[i].opcionFile === 'copiaescritura') contador++
                else if (opcionFilePredio[i].opcionFile === 'constanciaposesion') contador++
                else if (opcionFilePredio[i].opcionFile === 'contratoarrendamiento') contador += 3
                else if (opcionFilePredio[i].opcionFile === 'contratocompraventa') contador += 3
            }
            if (opcionFilePredio.length !== data.fc_01_anexoproductor.length) contador++
        }
        return contador
    }
    const contadorMarcas = () => {
        let contador = 0
        if (data.comercializadormezcal) {
            if (data.fc_01_anexomarcas.length > 0 && !data.envasador && !data.productormaguey) contador += (data.fc_01_anexomarcas.length * 2)
            if (data.fc_01_anexomarcas.length > 0 && !data.envasador && data.productormaguey) contador += (data.fc_01_anexomarcas.length * 2)
            if (data.fc_01_anexomarcas.length > 0 && data.envasador && !data.productormaguey) contador += (data.fc_01_anexomarcas.length * 1)
            if (data.fc_01_anexomarcas.length > 0 && data.envasador && data.productormaguey) contador += data.fc_01_anexomarcas.length
            for (const marca of data.fc_01_anexomarcas) {
                if (marca.registrosi && marca.idtitularidaddemarca == 1) contador += 1
                if (marca.registrosi && marca.idtitularidaddemarca == 3) contador += 2
                if (marca.registrosi && marca.idtitularidaddemarca == 4) contador += 2
                if (marca.registrosi && marca.idtitularidaddemarca == 5) contador += 3
                if (marca.registrosi && marca.idtitularidaddemarca == 6) contador += 2
                if (marca.registrono && marca.idtitularidaddemarca == 2) contador += 2
                if (marca.registrono && marca.idtitularidaddemarca == 5) contador += 2
                if (marca.registrono && marca.idtitularidaddemarca == 6) contador += 3
            }
        }

        if (data.comercializadorbebidasconmezcal) {
            if (data.fc_01_anexomarcasproductoconmezcal.length > 0 && !data.envasador && !data.productormaguey) contador += (data.fc_01_anexomarcasproductoconmezcal.length * 2)
            if (data.fc_01_anexomarcasproductoconmezcal.length > 0 && !data.envasador && data.productormaguey) contador += (data.fc_01_anexomarcasproductoconmezcal.length * 2)
            if (data.fc_01_anexomarcasproductoconmezcal.length > 0 && data.envasador && !data.productormaguey) contador += (data.fc_01_anexomarcasproductoconmezcal.length * 1)
            if (data.fc_01_anexomarcasproductoconmezcal.length > 0 && data.envasador && data.productormaguey) contador += data.fc_01_anexomarcasproductoconmezcal.length
            for (const marca of data.fc_01_anexomarcasproductoconmezcal) {
                if (marca.registrosi && marca.idtitularidaddemarca == 1) contador += 1
                if (marca.registrosi && marca.idtitularidaddemarca == 3) contador += 2
                if (marca.registrosi && marca.idtitularidaddemarca == 4) contador += 2
                if (marca.registrosi && marca.idtitularidaddemarca == 5) contador += 3
                if (marca.registrosi && marca.idtitularidaddemarca == 6) contador += 2
                if (marca.registrono && marca.idtitularidaddemarca == 2) contador += 2
                if (marca.registrono && marca.idtitularidaddemarca == 5) contador += 2
                if (marca.registrono && marca.idtitularidaddemarca == 6) contador += 3
            }
        }

        return contador
    }
    const contadorMoralGeneral = () => {
        let contador = 0
        if (data.viverista || data.productormaguey || data.productormezcal || data.envasador || data.comercializadorbebidasconmezcal || data.comercializadormezcal) {
            contador += 4
        }
        if (data.certificacionsi === true) contador += 1
        if (data.fc_01_anexorepresentantelegal.length > 0) contador += (data.fc_01_anexorepresentantelegal.length * 2)
        if (data.fc_01_anexopersonaautorizadatramites.length > 0) contador += data.fc_01_anexopersonaautorizadatramites.length
        return contador
    }
    const contadorInstalaciones = () => {
        let contador = 0
        if (data.anexo.length > 0) {
            // contador += anexoInstalaciones.length
            for (const i in opcionFileInstalacion) {
                if (opcionFileInstalacion[i].opcionFile === 'copiatitulopropiedad') contador++
                else if (opcionFileInstalacion[i].opcionFile === 'contratoarrendamientopublico') contador++
                else if (opcionFileInstalacion[i].opcionFile === 'contratoarrendamientoprivado') contador += 3
                else if (opcionFileInstalacion[i].opcionFile === 'contratocomodatopublico') contador += 1
                else if (opcionFileInstalacion[i].opcionFile === 'contratocomodatoprivado') contador += 3
            }
            if (opcionFileInstalacion.length !== data.anexo.length) contador++
            for (const i in data.anexo) {

                contador += data.anexo[i].informaciongeneral.responsables.length
            }
        }
        return contador
    }
    React.useEffect(() => {
        if (filesFC_01?.data) {
            let newFiles = []
            for (const file of filesFC_01.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFile(newFiles)
        }
        //filesApoderadosLegFC_01
        if (filesApoderadosLegFC_01?.data) {
            let newFiles = []
            for (const file of filesApoderadosLegFC_01.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFileApoderadosLeg(newFiles)
        }
        //filesPersonasAutFC_01
        if (filesPersonasAutFC_01?.data) {
            let newFiles = []
            for (const file of filesPersonasAutFC_01.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFilePersonasAut(newFiles)
        }
        //filesMarcasFC_01
        if (filesMarcasFC_01?.data) {
            let newFiles = []
            for (const file of filesMarcasFC_01.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFilesMarcas(newFiles)
        }
        //filesMarcasProductFC_01
        if (filesMarcasProductFC_01?.data) {
            let newFiles = []
            for (const file of filesMarcasProductFC_01.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFilesMarcasProduct(newFiles)
        }
        //filesInstalacionesFC_01
        if (filesInstalacionesFC_01?.data) {
            let newFiles = []
            for (const file of filesInstalacionesFC_01.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFileInstalaciones(newFiles)
        }
        //filesPrediosFC_01
        if (filesPrediosFC_01?.data) {
            let newFiles = []
            for (const file of filesPrediosFC_01.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFilePredios(newFiles)
        }
        //filesViverosFC_01
        if (filesViverosFC_01?.data) {
            let newFiles = []
            for (const file of filesViverosFC_01.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFileViveros(newFiles)
        }

        //filesResponsablesFC_01
        if (filesResponsablesFC_01?.data) {
            let newFiles = []
            for (const file of filesResponsablesFC_01.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFilesResponsables(newFiles)
        }

        //opcionesFilesPrediosFC_01
        if (opcionesFilesPrediosFC_01?.data) {
            let newOpciones = []
            for (const opcion of opcionesFilesPrediosFC_01.data) {
                const { ...newOpcion } = opcion
                newOpciones.push(newOpcion)
            }
            setOpcionFilePredio(newOpciones)
        }

        //opcionesFilesViverosFC_01
        if (opcionesFilesViverosFC_01?.data) {
            let newOpciones = []
            for (const opcion of opcionesFilesViverosFC_01.data) {
                const { ...newOpcion } = opcion
                newOpciones.push(newOpcion)
            }
            setOpcionFileVivero(newOpciones)
        }

        //opcionesInstalaciones
        if (opcionesFilesInstalacionesFC_01?.data) {
            let newOpciones = []
            for (const opcion of opcionesFilesInstalacionesFC_01.data) {
                const { ...newOpcion } = opcion
                newOpciones.push(newOpcion)
            }
            setOpcionFileInstalacion(newOpciones)
        }
    }, [fc_01, data])
    // const agregarFileFC_01 = async (data) => {
    //     const {archivo, ruta} = data
    //     const result = await agregarFile(archivo, ruta)
    //     return result
    // }
    // const agregarFile = async (data, url) => {
    //     let formData = new FormData();
    //     formData.append(1, data.file)
    //     formData.append('nameId', data.id)
    //     formData.append('idSolicitud', data.idAnexoFK)
    //     const resFile = await axios.post(host + url, formData, {
    //         headers: {
    //             'Content-Type': 'multipart/form-data'
    //         },
    //         onUploadProgress: (data) =>{
    //             setUploaded(Math.round((data.loaded/data.total) * 100))
    //             const file = files.filter(file => { file.id === data.id })
    //         }
    //     })
    //     return resFile
    // }
    //FILES GENERALES
    const [files, setFile] = React.useState([])
    const handdleFile = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_01/agregarAnexosArchivosFC_01'
        }
        const result = await dispatch(agregarFileFC_01(data))
        if (result.payload?.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idfc01_anexos
            objectFile.estatus = true
            setFile(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }


    }

    const handdleRemovePrev = async (objectFile) => {
        if (objectFile) {
            const newFiles = files.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_01/actualizarFileFC_01'
                }
                let result = await dispatch(actualizarFileFC_01(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_01/agregarAnexosArchivosFC_01'
                    }
                    result = await dispatch(agregarFileFC_01(data))
                }
                if (result.payload.data?.data) {
                    setFile(newFiles)
                    return true
                } else {
                    const newFiles = files.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFile(newFiles)
                    return false
                }
            }
        }
    }

    //FILES APODERADOS LEGALES
    const [filesApoderadosLeg, setFileApoderadosLeg] = React.useState([])
    const handdleFileApoderadoLeg = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_01/agregarNuevoArchivoAnexosRepresentanteLegal'
        }
        const result = await dispatch(agregarFileFC_01(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idanexorepresentantelegal
            objectFile.estatus = true
            setFileApoderadosLeg(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }

    }

    const handdleRemovePrevApoderadoLeg = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesApoderadosLeg.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_01/actualizarArchivoAnexosRepresentanteLegal'
                }
                const result = await dispatch(actualizarFileFC_01(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_01/agregarNuevoArchivoAnexosRepresentanteLegal'
                    }
                    result = await dispatch(agregarFileFC_01(data))
                }
                if (result.payload.data?.data) {
                    setFileApoderadosLeg(newFiles)
                    return true
                } else {
                    const newFiles = filesApoderadosLeg.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFileApoderadosLeg(newFiles)
                    return false
                }
            }
        }
    }
    //FILES PERSONAS AUTORIZADAS
    const [filesPersonasAut, setFilePersonasAut] = React.useState([])
    const handdleFilePersonasAut = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_01/agregarNuevoArchivoAnexosPersonaAutorizada'
        }
        const result = await dispatch(agregarFileFC_01(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idanexopersonaautorizada
            objectFile.estatus = true
            setFilePersonasAut(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemovePrevPersonasAut = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesPersonasAut.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_01/actualizarAnexosPersonaAutorizada'
                }
                const result = await dispatch(actualizarFileFC_01(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_01/agregarNuevoArchivoAnexosPersonaAutorizada'
                    }
                    result = await dispatch(agregarFileFC_01(data))
                }
                if (result.payload.data?.data) {
                    setFilePersonasAut(newFiles)
                    return true
                } else {
                    const newFiles = filesPersonasAut.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFilePersonasAut(newFiles)
                    return false
                }
            }
        }
    }

    //FILES MARCAS
    const [filesMarcas, setFilesMarcas] = React.useState([])
    const handdleFileMarcas = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_01/agregarNuevoArchivoAnexoDeMarca'
        }
        const result = await dispatch(agregarFileFC_01(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idanexomarca
            objectFile.estatus = true
            setFilesMarcas(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemovePrevMarcas = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesMarcas.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_01/actualizarAnexoDeMarca'
                }
                const result = await dispatch(actualizarFileFC_01(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_01/agregarNuevoArchivoAnexoDeMarca'
                    }
                    result = await dispatch(agregarFileFC_01(data))
                }
                if (result.payload.data?.data) {
                    setFilesMarcas(newFiles)
                    return true
                } else {
                    const newFiles = filesMarcas.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFilesMarcas(newFiles)
                    return false
                }
            }
        }
    }

    //FILES MARCAS PRODUCTO
    const [filesMarcasProduct, setFilesMarcasProduct] = React.useState([])
    const handdleFileMarcasProduct = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_01/agregarNuevoArchivoAnexoMarcaProducto'
        }
        const result = await dispatch(agregarFileFC_01(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idarchivosmarcaproducto
            objectFile.estatus = true
            setFilesMarcasProduct(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemovePrevMarcasProduct = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesMarcasProduct.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_01/actualizarArchivoAnexoMarcaProducto'
                }
                const result = await dispatch(actualizarFileFC_01(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_01/agregarNuevoArchivoAnexoMarcaProducto'
                    }
                    result = await dispatch(agregarFileFC_01(data))
                }
                if (result.payload.data?.data) {
                    setFilesMarcasProduct(newFiles)
                    return true
                } else {
                    const newFiles = filesMarcasProduct.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFilesMarcasProduct(newFiles)
                    return false
                }
            }
        }
    }

    // opcionSelect={{ handleChangeOptionFile: handleChangeOptionFileVivero, opcion: opcionFileVivero, handdleRemoveOptionFile: handdleRemoveOptionFileVivero, deletePrevFile: deletePrevVivero }} />
    //FILES VIVEROS
    const [filesViveros, setFileViveros] = React.useState([])
    const handdleFileVivero = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_01/agregarNuevoArchivoAnexosViveros'
        }
        const result = await dispatch(agregarFileFC_01(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idarchivosvivero
            objectFile.estatus = true
            setFileViveros(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemovePrevVivero = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesViveros.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_01/actualizarArchivoAnexosViveros'
                }
                const result = await dispatch(actualizarFileFC_01(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_01/agregarNuevoArchivoAnexosViveros'
                    }
                    result = await dispatch(agregarFileFC_01(data))
                }
                if (result.payload.data?.data) {
                    setFileViveros(newFiles)
                    return true
                } else {
                    const newFiles = filesViveros.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFileViveros(newFiles)
                    return false
                }
            }
        }
    }
    const [opcionFileVivero, setOpcionFileVivero] = React.useState([])
    const handleChangeOptionFileVivero = (option) => {
        setOpcionFileVivero(prev => [...prev, option])
    }
    const handdleRemoveOptionFileVivero = (objectOption) => {
        if (objectOption) {
            const newOptions = opcionFileVivero.map(field => {
                if (field.id === objectOption.id) {
                    field.opcionFile = objectOption.opcionFile
                    return (field)
                } else {
                    return (field)
                }
            })
            if (newOptions !== undefined) {
                setOpcionFileVivero(newOptions)
            }
        }
    }
    const deletePrevVivero = async (files, id) => {
        if (files) {
            let newFiles = []
            files.map(async (file, index) => {
                if (!(file.id).includes(id)) {
                    newFiles.push(file)
                } else {
                    const data = {
                        archivo: file,
                        ruta: 'FC_01/eliminarArchivoVivero'
                    }
                    await dispatch(eliminarFileFC_01(data))
                }
            })
            setFileViveros(newFiles)
        }
    }

    //FILES PREDIOS
    const [filesPredios, setFilePredios] = React.useState([])
    const handdleFilePredio = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_01/agregarNuevoFC_01ArchivosPredio'
        }
        const result = await dispatch(agregarFileFC_01(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idarchivospredio
            objectFile.estatus = true
            setFilePredios(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemovePrevPredio = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesPredios.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_01/actualizarArchivosPredio'
                }
                const result = await dispatch(actualizarFileFC_01(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_01/agregarNuevoFC_01ArchivosPredio'
                    }
                    result = await dispatch(agregarFileFC_01(data))
                }
                if (result.payload.data?.data) {
                    setFilePredios(newFiles)
                    return true
                } else {
                    const newFiles = filesPredios.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFilePredios(newFiles)
                    return false
                }
            }
        }
    }
    const [opcionFilePredio, setOpcionFilePredio] = React.useState([])
    const handleChangeOptionFilePredio = (option) => {
        setOpcionFilePredio(prev => [...prev, option])
    }
    const handdleRemoveOptionFilePredio = (objectOption) => {
        if (objectOption) {
            const newOptions = opcionFilePredio.map(field => {
                if (field.id === objectOption.id) {
                    field.opcionFile = objectOption.opcionFile
                    return (field)
                } else {
                    return (field)
                }
            })
            if (newOptions !== undefined) {
                setOpcionFilePredio(newOptions)
            }
        }
    }
    const deletePrevPredio = async (files, id) => {
        if (files) {
            let newFiles = []
            files.map(async (file, index) => {
                if (!(file.id).includes(id)) {
                    newFiles.push(file)
                } else {
                    const data = {
                        archivo: file,
                        ruta: 'FC_01/eliminarArchivoPredio'
                    }
                    await dispatch(eliminarFileFC_01(data))
                }
            })
            setFilePredios(newFiles)
        }
    }



    //handdleFile: handdleFileInstalaciones, handdleRemovePrev: handdleRemovePrevInstalaciones, files: filesInstalaciones }} idAnexoFK={anexo.idanexo} id={`INST${anexo.idanexo}`} tabla={"FC_01_anexosInstalacion"} anexo={anexo}
    //opcionSelect={{ handleChangeOptionFile: handleChangeOptionFileInstalacion, opcion: opcionFileInstalacion, handdleRemoveOptionFile: handdleRemoveOptionFileInstalacion, deletePrevFile: deletePrevInstalacion }} />
    //FILES INSTALACIONES
    const [filesInstalaciones, setFileInstalaciones] = React.useState([])
    const handdleFileInstalaciones = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_01/agregarNuevoArchivoAnexoInstalacion'
        }
        const result = await dispatch(agregarFileFC_01(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idarchivosinstalacion
            objectFile.estatus = true
            setFileInstalaciones(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemovePrevInstalaciones = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesInstalaciones.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_01/actualizarArchivoAnexoInstalacion'
                }
                const result = await dispatch(actualizarFileFC_01(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_01/agregarNuevoArchivoAnexoInstalacion'
                    }
                    result = await dispatch(agregarFileFC_01(data))
                }
                if (result.payload.data?.data) {
                    setFileInstalaciones(newFiles)
                    return true
                } else {
                    const newFiles = filesInstalaciones.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFileInstalaciones(newFiles)
                    return false
                }
            }
        }
    }
    const [opcionFileInstalacion, setOpcionFileInstalacion] = React.useState([])
    const handleChangeOptionFileInstalacion = (option) => {
        setOpcionFileInstalacion(prev => [...prev, option])
    }
    const handdleRemoveOptionFileInstalacion = (objectOption) => {
        if (objectOption) {
            const newOptions = opcionFileInstalacion.map(field => {
                if (field.id === objectOption.id) {
                    field.opcionFile = objectOption.opcionFile
                    return (field)
                } else {
                    return (field)
                }
            })
            if (newOptions !== undefined) {
                setOpcionFileInstalacion(newOptions)
            }
        }
    }
    const deletePrevInstalacion = async (files, id) => {
        if (files) {
            let newFiles = []
            files.map(async (file, index) => {
                if (!(file.id).includes(id)) {
                    newFiles.push(file)
                } else {
                    const data = {
                        archivo: file,
                        ruta: 'FC_01/eliminarArchivoInstalacion'
                    }
                    await dispatch(eliminarFileFC_01(data))
                }
            })
            setFileInstalaciones(newFiles)
        }
    }

    //FILES RESPONSABLES
    const [filesResponsables, setFilesResponsables] = React.useState([])
    const handdleFileResponsables = async (objectFile) => {
        const data = {
            archivo: objectFile,
            ruta: 'FC_01/agregarNuevoArchivoResponsable'
        }
        const result = await dispatch(agregarFileFC_01(data))
        if (result.payload.data?.data) {
            objectFile.idAnexo = result.payload.data.data.idarchivosresponsables
            objectFile.estatus = true
            setFilesResponsables(prev => [...prev, objectFile])
            return true
        } else {
            return false
        }
    }

    const handdleRemovePrevResponsables = async (objectFile) => {
        if (objectFile) {
            const newFiles = filesResponsables.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                const data = {
                    archivo: objectFile,
                    ruta: 'FC_01/actualizarArchivoResponsable'
                }
                const result = await dispatch(actualizarFileFC_01(data))
                if (result.payload === undefined) {
                    const data = {
                        archivo: objectFile,
                        ruta: 'FC_01/agregarNuevoArchivoResponsable'
                    }
                    result = await dispatch(agregarFileFC_01(data))
                }
                if (result.payload.data?.data) {
                    setFilesResponsables(newFiles)
                    return true
                } else {
                    const newFiles = filesResponsables.map(file => {
                        if (file.id === objectFile.id) {
                            file.estatus = false
                            return (file)
                        } else {
                            return (file)
                        }
                    })
                    setFilesResponsables(newFiles)
                    return false
                }
            }
        }
    }
    const documentacionGeneralFisica = () => {
        if (data.viverista || data.productormaguey || data.productormezcal || data.envasador || data.comercializadorbebidasconmezcal || data.comercializadormezcal) {
            return (
                <div>
                    <Collapsible trigger="Agregar documentación general" className={`${estilos.collapsible} mb-3`}>
                        <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                            {
                                <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGIOV'} tabla={"FC_01_anexos"} textLabel={`Identificación oficial vigente del solicitante: ${data.nombrerazonsocial}`} idAnexoFK={data.idfc01_solicitudregistro} filesMap={documentacionFC_01Map} />
                            }
                            <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGCDF'} tabla={"FC_01_anexos"} textLabel="Comprobante de domicilio Fiscal." textoTooltip='No mayor a 3 meses de antigüedad' idAnexoFK={data.idfc01_solicitudregistro} filesMap={documentacionFC_01Map} />
                            {(data.productormaguey && !data.viverista && !data.productormezcal && !data.envasador && !data.comercializadorbebidasconmezcal && !data.comercializadormezcal) ?
                                '' : <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGRFC'} tabla={"FC_01_anexos"} textLabel="Constancia de situación fiscal (RFC)." textoTooltip='No mayor a tres meses de antigüedad' idAnexoFK={data.idfc01_solicitudregistro} filesMap={documentacionFC_01Map} />
                            }
                            {
                                data.representantelegalsi &&
                                <>
                                    <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGIOVREP'} tabla={"FC_01_anexos"} textLabel={`Identificación oficial vigente del apoderado legal: ${data.representantelegal}`} idAnexoFK={data.idfc01_solicitudregistro} filesMap={documentacionFC_01Map} />
                                </>
                            }
                            {
                                data.fc_01_anexopersonaautorizadatramites.map((personaAut, index) => (
                                    <>
                                        <ArchivoComponent api={{ handdleFile: handdleFilePersonasAut, handdleRemovePrev: handdleRemovePrevPersonasAut, files: filesPersonasAut }} idAnexoFK={personaAut.idfc01_anexopersonaatorizadatramites} id={`DGIOVAUT${personaAut.idfc01_anexopersonaatorizadatramites}`} tabla={"FC_01_anexopersonaautorizada"} textLabel={`Identificación oficial vigente de la persona autorizada: ${personaAut.personaautoriazadaparatramites}`} filesMap={documentacionPersonaAutorizadaMap} />
                                    </>
                                ))
                            }
                            {
                                data.certificacionsi &&
                                <>
                                    <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGC'} tabla={"FC_01_anexos"} textLabel={`Documento que acredite su certificación ${data.empresacertificadora}`} idAnexoFK={data.idfc01_solicitudregistro} filesMap={documentacionFC_01Map} />
                                </>
                            }
                        </div>
                    </Collapsible>
                </div>

            )
        }
    }

    const documentacionGeneralMoral = () => {
        if (data.viverista || data.productormaguey || data.productormezcal || data.envasador || data.comercializadorbebidasconmezcal || data.comercializadormezcal) {
            return (
                <div>
                    <Collapsible trigger="Agregar documentación general" className='mb-3'>
                        <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                            <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={`DGAC`} tabla={"FC_01_anexos"} textLabel="Acta constitutiva notariada" idAnexoFK={data.idfc01_solicitudregistro} filesMap={documentacionFC_01Map} />
                            <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={`DGPN`} tabla={"FC_01_anexos"} textLabel="Poder notarial del representante legal o última acta de asamblea notariada." textoTooltip='En caso de no acreditarse en su acta constitutiva' idAnexoFK={data.idfc01_solicitudregistro} filesMap={documentacionFC_01Map} />

                            <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={`DGIOVREP`} tabla={"FC_01_anexos"} textLabel={`Identificación oficial vigente del representante legal: ${data.representantelegal}`} idAnexoFK={data.idfc01_solicitudregistro} filesMap={documentacionFC_01Map} />
                            {
                                data.fc_01_anexorepresentantelegal.map((representante, index) => (
                                    <>
                                        <ArchivoComponent api={{ handdleFile: handdleFileApoderadoLeg, handdleRemovePrev: handdleRemovePrevApoderadoLeg, files: filesApoderadosLeg }} idAnexoFK={representante.idfc01_anexorepresentantelegal} id={`DGIOVAP${representante.idfc01_anexorepresentantelegal}`} tabla={"FC_01_anexorepresentantelegal"} textLabel={`Identificación oficial vigente del apoderado legal: ${representante.representantelegal}`} filesMap={documentacionRepresentanteLegalMap} />
                                        <ArchivoComponent api={{ handdleFile: handdleFileApoderadoLeg, handdleRemovePrev: handdleRemovePrevApoderadoLeg, files: filesApoderadosLeg }} idAnexoFK={representante.idfc01_anexorepresentantelegal} id={`DGPNAP${representante.idfc01_anexorepresentantelegal}`} tabla={"FC_01_anexorepresentantelegal"} textLabel={`Poder notarial`} filesMap={documentacionRepresentanteLegalMap} />
                                    </>
                                ))
                            }
                            <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGCDF'} tabla={"FC_01_anexos"} textLabel="Comprobante de domicilio Fiscal." textoTooltip='No mayor a 3 meses de antigüedad' idAnexoFK={data.idfc01_solicitudregistro} filesMap={documentacionFC_01Map} />
                            {(data.productormaguey && !data.viverista && !data.productormezcal && !data.envasador && !data.comercializadorbebidasconmezcal && !data.comercializadormezcal) ?
                                '' : <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGRFC'} tabla={"FC_01_anexos"} textLabel="Constancia de situación fiscal (RFC)." textoTooltip='No mayor a tres meses de antigüedad' idAnexoFK={data.idfc01_solicitudregistro} filesMap={documentacionFC_01Map} />
                            }
                            {
                                data.fc_01_anexopersonaautorizadatramites.map((personaAut, index) => (
                                    <>
                                        <ArchivoComponent api={{ handdleFile: handdleFilePersonasAut, handdleRemovePrev: handdleRemovePrevPersonasAut, files: filesPersonasAut }} idAnexoFK={personaAut.idfc01_anexopersonaatorizadatramites} id={`DGIOVAUT${personaAut.idfc01_anexopersonaatorizadatramites}`} tabla={"FC_01_anexopersonaautorizada"} textLabel={`Identificación oficial vigente de la persona autorizada: ${personaAut.personaautoriazadaparatramites}`} filesMap={documentacionPersonaAutorizadaMap} />
                                    </>
                                ))
                            }
                            {
                                data.certificacionsi &&
                                <>
                                    <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGC'} tabla={"FC_01_anexos"} textLabel={`Certificación de la empresa: ${data.empresacertificadora}`} idAnexoFK={data.idfc01_solicitudregistro} filesMap={documentacionFC_01Map} />
                                </>
                            }
                        </div>
                    </Collapsible>
                </div>
            )
        }
    }

    const viveristaProductorFisicaFiles = () => {
        let nameDocumentacion = ''
        if (data.viverista) nameDocumentacion = 'viverista'
        if (data.productormaguey && data.viverista) nameDocumentacion += '/productor maguey'
        else if (data.productormaguey) nameDocumentacion = 'productor maguey'
        if (data.viverista || data.productormaguey) {
            return (
                <div>
                    <Collapsible trigger={`Agregar documentación de ${nameDocumentacion}`} className='mb-3'>
                        <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                            {
                                data.fc_01_anexovivero.map((vivero, index) => (
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <ArchivosPrediosViveros api={{ handdleFile: handdleFileVivero, handdleRemovePrev: handdleRemovePrevVivero, files: filesViveros }} idAnexoFK={vivero.idfc01_anexopredios}
                                            id={`VIV${vivero.idfc01_anexopredios}`} tabla={"FC_01_anexos"} anexo={vivero} name='Vivero' tipo={'Vivero'}
                                            opcionSelect={{ handleChangeOptionFile: handleChangeOptionFileVivero, opcion: opcionFileVivero, handdleRemoveOptionFile: handdleRemoveOptionFileVivero, deletePrevFile: deletePrevVivero }} filesMap={documentacionViveroMap} />
                                    </div>
                                ))
                            }
                            {
                                data.fc_01_anexoproductor.map((predio, index) => (
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <ArchivosPrediosViveros api={{ handdleFile: handdleFilePredio, handdleRemovePrev: handdleRemovePrevPredio, files: filesPredios }} idAnexoFK={predio.idfc01_anexoproductor}
                                            id={`PRED${predio.idfc01_anexoproductor}`} tabla={"FC_01_anexos"} anexo={predio} name='Predio' tipo={'Predio'}
                                            opcionSelect={{ handleChangeOptionFile: handleChangeOptionFilePredio, opcion: opcionFilePredio, handdleRemoveOptionFile: handdleRemoveOptionFilePredio, deletePrevFile: deletePrevPredio }} filesMap={documentacionPredioMap} />
                                    </div>
                                ))
                            }
                        </div>
                    </Collapsible>

                </div>
            )
        }
    }

    const viveristaProductorMoralFiles = () => {
        let nameDocumentacion = ''
        if (data.viverista) nameDocumentacion = 'viverista'
        if (data.productormaguey && data.viverista) nameDocumentacion += '/productor maguey'
        else if (data.productormaguey) nameDocumentacion = 'productor maguey'
        if (data.viverista || data.productormaguey) {
            return (
                <div>
                    <Collapsible trigger={`Agregar documentación de ${nameDocumentacion}`} className='mb-3'>
                        <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                            {
                                data.fc_01_anexovivero.map((vivero, index) => (
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <ArchivosPrediosViveros api={{ handdleFile: handdleFileVivero, handdleRemovePrev: handdleRemovePrevVivero, files: filesViveros }} idAnexoFK={vivero.idfc01_anexopredios}
                                            id={`VIV${vivero.idfc01_anexopredios}`} tabla={"FC_01_anexos"} anexo={vivero} name='Vivero' tipo={'Vivero'}
                                            opcionSelect={{ handleChangeOptionFile: handleChangeOptionFileVivero, opcion: opcionFileVivero, handdleRemoveOptionFile: handdleRemoveOptionFileVivero, deletePrevFile: deletePrevVivero }} filesMap={documentacionViveroMap} />
                                    </div>
                                ))
                            }
                            {
                                data.fc_01_anexoproductor.map((predio, index) => (
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <ArchivosPrediosViveros api={{ handdleFile: handdleFilePredio, handdleRemovePrev: handdleRemovePrevPredio, files: filesPredios }} idAnexoFK={predio.idfc01_anexoproductor}
                                            id={`PRED${predio.idfc01_anexoproductor}`} tabla={"FC_01_anexos"} anexo={predio} name='Predio' tipo={'Predio'}
                                            opcionSelect={{ handleChangeOptionFile: handleChangeOptionFilePredio, opcion: opcionFilePredio, handdleRemoveOptionFile: handdleRemoveOptionFilePredio, deletePrevFile: deletePrevPredio }} filesMap={documentacionPredioMap} />
                                    </div>
                                ))
                            }
                        </div>
                    </Collapsible>

                </div>
            )
        }
    }

    const comercializadorFisicaFiles = () => {
        if (data.comercializadorbebidasconmezcal || data.comercializadormezcal) {
            return (
                <div>
                    <Collapsible trigger="Agregar documentación de sus Marcas" className='mb-3'>
                        <div className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                            {
                                data.fc_01_anexomarcas.map((marca, index) => (
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <ArchivosMarcaComponent api={{ handdleFile: handdleFileMarcas, handdleRemovePrev: handdleRemovePrevMarcas, files: filesMarcas }} idAnexoFK={marca.idfc01_anexomarcas} id={`MARCAMEZCAL${marca.idfc01_anexomarcas}`} tabla={"FC_01_anexosMarca"} key={index} marca={marca} namePK={'idfc01_anexomarcas'} filesMap={documentacionMarcaMap} />
                                        {
                                            !data.envasador &&
                                            <ArchivoComponent api={{ handdleFile: handdleFileMarcas, handdleRemovePrev: handdleRemovePrevMarcas, files: filesMarcas }} idAnexoFK={marca.idfc01_anexomarcas} id={`MARCAMEZCALCONTRATO${marca.idfc01_anexomarcas}`} tabla={"FC_01_anexosMarca"} textLabel="Contrato de maquila con un envasador" filesMap={documentacionMarcaMap} />
                                        }
                                        {
                                            !(
                                                (data.productormezcal && (data.comercializadorbebidasconmezcal || data.comercializadormezcal)) ||
                                                ((data.productormaguey || data.productormezcal) && data.envasador && (data.comercializadorbebidasconmezcal || data.comercializadormezcal)) ||
                                                (data.productormezcal && data.comercializadorbebidasconmezcal && data.comercializadormezcal) ||
                                                (data.productormaguey && data.productormezcal && data.envasador && data.comercializadormezcal && data.comercializadorbebidasconmezcal)
                                            ) &&
                                            <ArchivoComponent api={{ handdleFile: handdleFileMarcas, handdleRemovePrev: handdleRemovePrevMarcas, files: filesMarcas }} idAnexoFK={marca.idfc01_anexomarcas} id={`MARCAMEZCALCONVENIO${marca.idfc01_anexomarcas}`} tabla={"FC_01_anexosMarca"} textLabel="Convenio de corresponsabilidad autorizado por el IMPI" filesMap={documentacionMarcaMap} />
                                        }
                                    </div>
                                ))
                            }
                            {
                                data.fc_01_anexomarcasproductoconmezcal.map((marca, index) => (
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <ArchivosMarcaComponent api={{ handdleFile: handdleFileMarcasProduct, handdleRemovePrev: handdleRemovePrevMarcasProduct, files: filesMarcasProduct }} idAnexoFK={marca.idfc01_anexomarcasproductoconmezcal} id={`MARCACONMEZCAL${marca.idfc01_anexomarcasproductoconmezcal}`} tabla={"FC_01_anexosMarca"} key={index} marca={marca} namePK={'idfc01_anexomarcasproductoconmezcal'} filesMap={documentacionMarcaProductoMap} />
                                        {
                                            !data.envasador &&
                                            <ArchivoComponent api={{ handdleFile: handdleFileMarcasProduct, handdleRemovePrev: handdleRemovePrevMarcasProduct, files: filesMarcasProduct }} idAnexoFK={marca.idfc01_anexomarcasproductoconmezcal} id={`MARCACONMEZCALCONTRATO${marca.idfc01_anexomarcasproductoconmezcal}`} tabla={"FC_01_anexosMarca"} textLabel="Contrato de maquila con un envasador" filesMap={documentacionMarcaProductoMap} />
                                        }
                                        {
                                            !(
                                                (data.productormezcal && (data.comercializadorbebidasconmezcal || data.comercializadormezcal)) ||
                                                ((data.productormaguey || data.productormezcal) && data.envasador && (data.comercializadorbebidasconmezcal || data.comercializadormezcal)) ||
                                                (data.productormezcal && data.comercializadorbebidasconmezcal && data.comercializadormezcal) ||
                                                (data.productormaguey && data.productormezcal && data.envasador && data.comercializadormezcal && data.comercializadorbebidasconmezcal)
                                            ) &&
                                            <ArchivoComponent api={{ handdleFile: handdleFileMarcasProduct, handdleRemovePrev: handdleRemovePrevMarcasProduct, files: filesMarcasProduct }} idAnexoFK={marca.idfc01_anexomarcasproductoconmezcal} id={`MARCACONMEZCALCONVENIO${marca.idfc01_anexomarcasproductoconmezcal}`} tabla={"FC_01_anexosMarca"} textLabel="Convenio de corresponsabilidad autorizado por el IMPI" filesMap={documentacionMarcaProductoMap} />
                                        }
                                    </div>
                                ))
                            }
                        </div>
                    </Collapsible>

                </div>

            )
        }
    }

    const comercializadorMoralFiles = () => {
        if (data.comercializadorbebidasconmezcal || data.comercializadormezcal) {
            return (
                <div>
                    <Collapsible trigger="Agregar documentación de sus Marcas" className='mb-3'>
                        <div className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                            {
                                data.fc_01_anexomarcas.map((marca, index) => (
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <ArchivosMarcaComponent api={{ handdleFile: handdleFileMarcas, handdleRemovePrev: handdleRemovePrevMarcas, files: filesMarcas }} idAnexoFK={marca.idfc01_anexomarcas} id={`MARCAMEZCAL${marca.idfc01_anexomarcas}`} tabla={"FC_01_anexosMarca"} key={index} marca={marca} namePK={'idfc01_anexomarcas'} filesMap={documentacionMarcaMap} />
                                        {
                                            !data.envasador &&
                                            <ArchivoComponent api={{ handdleFile: handdleFileMarcas, handdleRemovePrev: handdleRemovePrevMarcas, files: filesMarcas }} idAnexoFK={marca.idfc01_anexomarcas} id={`MARCAMEZCALCONTRATO${marca.idfc01_anexomarcas}`} tabla={"FC_01_anexosMarca"} textLabel="Contrato de maquila con un envasador" filesMap={documentacionMarcaMap} />
                                        }
                                        {
                                            !(
                                                (data.productormezcal && data.comercializadorbebidasconmezcal && data.comercializadormezcal) ||
                                                (data.productormaguey && data.productormezcal) ||
                                                (data.envasador && (data.comercializadorbebidasconmezcal || data.comercializadormezcal)) ||
                                                (data.productormaguey) && (data.productormezcal) ||
                                                (data.envasador)
                                            ) &&
                                            <ArchivoComponent api={{ handdleFile: handdleFileMarcas, handdleRemovePrev: handdleRemovePrevMarcas, files: filesMarcas }} idAnexoFK={marca.idfc01_anexomarcas} id={`MARCAMEZCALCONVENIO${marca.idfc01_anexomarcas}`} tabla={"FC_01_anexosMarca"} textLabel="Convenio de corresponsabilidad autorizado por el IMPI" filesMap={documentacionMarcaMap} />
                                        }
                                    </div>
                                ))
                            }
                            {
                                data.fc_01_anexomarcasproductoconmezcal.map((marca, index) => (
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <ArchivosMarcaComponent api={{ handdleFile: handdleFileMarcasProduct, handdleRemovePrev: handdleRemovePrevMarcasProduct, files: filesMarcasProduct }} idAnexoFK={marca.idfc01_anexomarcasproductoconmezcal} id={`MARCACONMEZCAL${marca.idfc01_anexomarcasproductoconmezcal}`} tabla={"FC_01_anexosMarca"} key={index} marca={marca} namePK={'idfc01_anexomarcasproductoconmezcal'} filesMap={documentacionMarcaProductoMap} />
                                        {
                                            !data.envasador &&
                                            <ArchivoComponent api={{ handdleFile: handdleFileMarcasProduct, handdleRemovePrev: handdleRemovePrevMarcasProduct, files: filesMarcasProduct }} idAnexoFK={marca.idfc01_anexomarcasproductoconmezcal} id={`MARCACONMEZCALCONTRATO${marca.idfc01_anexomarcasproductoconmezcal}`} tabla={"FC_01_anexosMarca"} textLabel="Contrato de maquila con un envasador" filesMap={documentacionMarcaProductoMap} />
                                        }
                                        {
                                            !(
                                                (data.productormezcal && data.comercializadorbebidasconmezcal && data.comercializadormezcal) ||
                                                (data.productormaguey && data.productormezcal) ||
                                                (data.envasador && (data.comercializadorbebidasconmezcal || data.comercializadormezcal)) ||
                                                (data.productormaguey) && (data.productormezcal) ||
                                                (data.envasador)
                                            ) &&
                                            <ArchivoComponent api={{ handdleFile: handdleFileMarcasProduct, handdleRemovePrev: handdleRemovePrevMarcasProduct, files: filesMarcasProduct }} idAnexoFK={marca.idfc01_anexomarcasproductoconmezcal} id={`MARCACONMEZCALCONVENIO${marca.idfc01_anexomarcasproductoconmezcal}`} tabla={"FC_01_anexosMarca"} textLabel="Convenio de corresponsabilidad autorizado por el IMPI" filesMap={documentacionMarcaProductoMap} />
                                        }
                                    </div>
                                ))
                            }
                        </div>
                    </Collapsible>
                </div>
            )
        }
    }

    const instalacionesFiles = () => {
        if (data.productormezcal || data.envasador || data.comercializadorbebidasconmezcal || data.comercializadormezcal && data.anexo.length > 0) {
            return (
                <div>
                    <Collapsible trigger="Agregar documentación de instalaciones" className='mb-3'>
                        <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                            {
                                data.anexo.map((anexo, index) => (
                                    <div key={index} className={`col-md-12 mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                                        <h5 className='text-center' style={{ color: 'black' }}>{anexo.idtipoanexo === 1 ? "Unidad de Producción" : anexo.idtipoanexo === 2 ? "Unidad de Envasado" : "Unidad de Almacén"}</h5>
                                        <ArchivosInstalaciones api={{ handdleFile: handdleFileInstalaciones, handdleRemovePrev: handdleRemovePrevInstalaciones, files: filesInstalaciones }} idAnexoFK={anexo.idanexo} id={`INST${anexo.idanexo}`} tabla={"FC_01_anexosInstalacion"} anexo={anexo}
                                            opcionSelect={{ handleChangeOptionFile: handleChangeOptionFileInstalacion, opcion: opcionFileInstalacion, handdleRemoveOptionFile: handdleRemoveOptionFileInstalacion, deletePrevFile: deletePrevInstalacion }} filesMap={documentacionInstalacionMap} />
                                        {
                                            anexo.informaciongeneral.responsables.map((responsable, indexR) => (

                                                <>
                                                    <ArchivoComponent api={{ handdleFile: handdleFileResponsables, handdleRemovePrev: handdleRemovePrevResponsables, files: filesResponsables }} idAnexoFK={responsable.idresponsabledeinstalacion} id={`INSTREP${anexo.idanexo}${responsable.idresponsabledeinstalacion}`} tabla={"FC_01_anexosResponsablesInstalacion"}
                                                        textLabel={`Identificación oficial vigente del responsable: ${responsable.nombreresponsable}`} filesMap={documentacionResponsableMap} />
                                                </>
                                            ))
                                        }
                                    </div>
                                ))
                            }
                        </div>
                    </Collapsible>
                </div>
            )
        }
    }
    const ComprobanteFile = () => {
        return (
            <div>
                <Collapsible trigger="Agregar comprobante de pago" className='mb-3'>
                    <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                        <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGCP'} tabla={"FC_01_anexos"}
                            textLabel={`Comprobante de pago: `} comprobantepago={data.comprobantepago} comprobantepagotext={data.comprobantepagotext} idAnexoFK={data.idfc01_solicitudregistro} />
                        <span style={{ color: 'black', fontSize: '14px', textAlign: 'left' }}> Para realizar el pago correspondiente, solicite su cotización al correo de <u style={{ color: 'blue' }}>info@comercam-dom.org.mx </u>
                            o a los teléfonos: 951 517 45 79 / 951 672 41 95 / 951 672 22 12 (<b>Nota:</b> Solo se dictaminarán
                            instalaciones de producción de mezcal y envasado que se encuentren dentro de los estados con Denominación de Origen).
                            <b> ¡Si, aún no cuentas con la cotización da clic en finalizar envío y un ejecutivo se pondrá en contacto contigo!</b></span>
                    </div>
                </Collapsible>
            </div>
        )
    }
    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    return (
        <Fragment>
            <div className='row container ms-5'>
                {
                    (data.personafisica) ? (
                        <Fragment>
                            {documentacionGeneralFisica()}
                            {viveristaProductorFisicaFiles()}
                            {comercializadorFisicaFiles()}
                            {instalacionesFiles()}
                            {((data.viverista || data.productormaguey) && !(data.productormezcal || data.envasador || data.comercializadormezcal || data.comercializadorbebidasconmezcal)) ?
                                <Fragment></Fragment> : ComprobanteFile()}

                        </Fragment>
                    ) : (
                        <Fragment>
                            {documentacionGeneralMoral()}
                            {viveristaProductorMoralFiles()}
                            {comercializadorMoralFiles()}
                            {instalacionesFiles()}
                            {((data.viverista || data.productormaguey) && !(data.productormezcal || data.envasador || data.comercializadormezcal || data.comercializadorbebidasconmezcal)) ?
                                <Fragment></Fragment> : ComprobanteFile()}
                        </Fragment>
                    )

                }
                <br />
                {
                    !modoCorreccion &&
                    <div className="text-center">
                        <button type="submit" onClick={() => obtenerNumeroDeFiles()}
                            className={`btn ${estilos.botonNaranjaRedondo}`}>Finalizar Envio</button>
                    </div>
                }

            </div>
            {envioCorrecto && <ModalEnviadoCorrectamente folioSolicitud={data.folio}></ModalEnviadoCorrectamente>}
            {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
        </Fragment>
    )
};

export default withRouter(DocumentacionFC_01Component)
